import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLetsFindYourFloor } from "../hooks/useLetsFindYourFloor";
import { getLetsFindYourFloorBestFind } from "../services/letsFindYourFloorBestFind.service";

function LetsFindYourFloor() {
  const [banners, setBanners] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const res = await getLetsFindYourFloorBestFind();
      setBanners(res);
    };
    fetchData();
  }, []);

  const floatingImages = useLetsFindYourFloor(banners);
  if (!floatingImages.length) return null;

  return (
    <section className="floor-matcher">
      {floatingImages.map((img, index) => (
        <img
          key={img.id}
          src={img.src}
          className={`floating-imgf ${img.className}`}
          style={{
            animationDelay: `${index * 1}s`, // stagger effect
          }}
          alt=""
        />
      ))}

      <div className="matcher-content">
        <h2>
          Let’s Find Your <br /> <em>Floor’s Best Friend</em>
        </h2>
        <p>
          Your style, your space, your vibe. We’ll help you match it with the
          right floor covering.
        </p>
        <Link to="/floor-matcher">
          <button className="hero-button">TRY FLOOR MATCHER</button>
        </Link>
      </div>
    </section>
  );
}
export default LetsFindYourFloor;